export function isAiKakuninUser(username: string): boolean {
  return [
    // KD(★管理者)
    ['stk_super_admin', true], // 首都技用(完全一致)
    ['honshi-6KZhWSqt', true], // 本四高速用(完全一致)
    ['koufu-kasen-7dfZH', true], // 甲府河川国道事務所(完全一致)
    ['shinchitose-airport-q6BTx', true], // 新千歳空港用(完全一致)
    ['yurikamome-super-admin-Fee4p', true], // ゆりかもめ(完全一致)
    ['iwaki-super-admin-uth7N', true], // いわき(完全一致)
    ['nagoya_super_admin', true], // 名古屋高速(完全一致)
    ['nagano-super-admin-faeV4', true], // 長野国道用(完全一致)
    // KD(開発)
    ['honshi-kaihatsu0001-MKZ3g', true], // 本四高速用(完全一致)
    ['koufu-kasen-kaihatsu0001-Rl6vd', true], // 甲府河川国道事務所(完全一致)
    ['shinchitose-airport-kaihatsu0001-GP6Rl', true], // 新千歳空港用(完全一致)
    // 首都技
    ['shutogi-ai-kakunin-Fz4Vd', true], // (完全一致)
    // 本四高速
    ['HNS-KNS', false], // (前方一致)
    // 甲府河川国道事務所
    ['KTR-KFR', false], // (前方一致)
    // 新千歳空港
    ['SPK-CTS', false], // (前方一致)
    // ゆりかもめ
    ['YKM-YKM', false], // (前方一致)
    // いわき
    ['IWK-IWK', false], // (前方一致)
    // 名古屋高速
    ['NEA-NGY', false], // (前方一致)
    // 長野国道
    ['KTR-NGN', false], // (前方一致)
    ['NGN-HTY', false], // (前方一致)
    // IFPデモ
    ['IFP-DEMO', false], // (前方一致)
    ['ifpspdemo', false], // (前方一致)
  ].findIndex(([_username, isExactMatch]) => {
    return isExactMatch ? username === _username : username.startsWith(_username.toString());
  }) !== -1;
}
